import { render } from "./MergedItemsModal.vue?vue&type=template&id=5c08edaa&scoped=true"
import script from "./MergedItemsModal.vue?vue&type=script&lang=js"
export * from "./MergedItemsModal.vue?vue&type=script&lang=js"

import "./MergedItemsModal.vue?vue&type=style&index=0&id=5c08edaa&lang=sass&scoped=true"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c08edaa"]])

export default __exports__